export default [
  'M28.4,20h-5.4v19h-8V20h-3.8v-6.7h3.8V9c0-3.1,1.5-8,8.1-8l6,0v6.5h-4.3c-0.7,0-1.7,0.3-1.7,1.8v3.9h6.1C29.1,13.3,28.4,20,28.4,20z',
];
